import 'css-chunksrc/client/common/filterMenu/eraseButton/styles.scss';export default {
  "eraseButton": "_eraseButton_4rj3p_1"
};